import { FormItem, FormLabel } from "@/components/ui/form";
import { useTranslation } from "react-i18next";
import { PhotoUploader } from "@/components/blocks/Support/PhotoUploader";

interface PhotoFormFieldProps {
  label?: string;
  onPhotoSelect: (file: File) => void;
  onPhotoRemove: () => void;
  photoPreview: string | null;
}

export function PhotoFormField({
  label,
  onPhotoSelect,
  onPhotoRemove,
  photoPreview,
}: PhotoFormFieldProps) {
  const { t } = useTranslation();

  return (
    <FormItem>
      {label && <FormLabel>{t(label)}</FormLabel>}
      <div className="space-y-2">
        <PhotoUploader
          onPhotoSelect={onPhotoSelect}
          onPhotoRemove={onPhotoRemove}
          photoPreview={photoPreview}
        />
      </div>
    </FormItem>
  );
}
